// Popup rápido no meio da tela ("Seja bem-vindo de volta, FULANO!"): aparece,
// fica 1,2 s e some. Pedido do dono (09/09/2026) — substitui o toast do rodapé.
import { UserCheck } from "lucide-react";
import { useEffect } from "react";

export default function PopupBoasVindas({ mensagem, onFim, duracao = 1200 }) {
  useEffect(() => {
    if (!mensagem) return undefined;
    const t = setTimeout(() => onFim?.(), duracao);
    return () => clearTimeout(t);
  }, [mensagem, duracao, onFim]);

  if (!mensagem) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center pointer-events-none" data-e2e="popup-boas-vindas">
      <style>{`
        @keyframes boas-vindas-pop { 0% { opacity: 0; transform: scale(0.85) translateY(12px); } 15% { opacity: 1; transform: scale(1) translateY(0); } 80% { opacity: 1; } 100% { opacity: 0; transform: scale(0.97) translateY(-8px); } }
      `}</style>
      <div className="flex items-center gap-4 rounded-3xl bg-zinc-900/95 border border-primary/40 shadow-2xl px-8 py-6" style={{ animation: `boas-vindas-pop ${duracao}ms ease-in-out both` }}>
        <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center shrink-0"><UserCheck className="w-8 h-8 text-primary" /></div>
        <p className="text-2xl md:text-3xl font-black text-zinc-100">{mensagem}</p>
      </div>
    </div>
  );
}
